var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { mq } from "core/styles/snippets";
import { config, Env, Id } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { SeasonCollection } from "pages/program/components/SeasonCollection";
import React from "react";
import styled from "styled-components";
export var block = function (program) {
    return Option.some({
        key: "programSeasonEpisodes",
        View: function () {
            if (!Env.isClient)
                return null;
            if (!program ||
                !program.vtmGoContent ||
                (!program.vtmGoContent.programInfo.comingSoonOnVtmGoPlus &&
                    program.vtmGoContent.episodeList.length === 0))
                return null;
            return (React.createElement(StyledSeasonCollection, { componentId: Id.component.contentCollection.season, listName: config.tracking.listNames.season, image: program.image, vtmGoContent: program.vtmGoContent, isPlus: program.vtmgoPlusExclusive, trackingEnabled: !program.fetchingData, programUuid: program.uuid, vtmgoUrl: program.hero.vtmgoUrl }));
        },
    });
};
var StyledSeasonCollection = styled(SeasonCollection)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 120rem;\n  padding: 0 1rem;\n  margin: 0 auto;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n  }\n"], ["\n  width: 100%;\n  max-width: 120rem;\n  padding: 0 1rem;\n  margin: 0 auto;\n\n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n  }\n"])), mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"));
var templateObject_1;
